import React from "react";
import { Form } from "react-bulma-components";

import { useEnumeratedDataTable } from "redux/features/enumeratedDataValues";
import SimpleSelect from "util/simpleSelect";

const { Help } = Form;

function LgbtqEtcComponent({ getValue, setValue, forSummary, RenderField }) {
  const { list: booleans, lookup: booleanLookup } = useEnumeratedDataTable(
    "optional_boolean_values"
  );
  const currentValue = getValue("lgbtq_etc_id");
  return (
    <RenderField
      label="LGBTQ2+?"
      question="Do you identify as LGBTQ2+?"
      value={currentValue}
      valueLookup={booleanLookup}
    >
      <SimpleSelect
        currentValue={currentValue}
        setValue={(newId) => setValue("lgbtq_etc_id", newId)}
        valueObjects={booleans}
        alwaysNumeric
      />

      <Help>
        LGBTQ2+ refers to lesbian, gay, bisexual, or another minority sexual
        identity such as asexual or pansexual, as well as minority gender
        identity (trans and non-binary identities like genderqueer, gender
        fluid, pangender or agender.
      </Help>
    </RenderField>
  );
}

export default LgbtqEtcComponent;
